import React, { Component } from 'react';
import classNames from 'classnames';
import { debounce } from '../../global/js/helpers.js';
import { globalData } from '../../global/js/globalData.js';
import StayComponentCommentBox from '../StayComponentCommentBox/StayComponentCommentBox'
import TappableStayComponentCard from '../TappableStayComponentCard/TappableStayComponentCard';
import './TappableStayComponent.scss';

class TappableStayComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            componentComment: this.props.componentComment,
            showTextarea: this.props.isNegativeExperience
        };
    }

    /**
     * Called when the 'N/A' checkbox on the text area is clicked.
     * Toggles the 'didNotRun' property of the given stay component.
     */
    handleDidNotRun = (event) => {
        this.props.actions.setComponentAnswer({
            id: event.target.dataset.id,
            didNotRun: true
        });
    }

    /**
     * Called each time a character is entered/removed in the comment textarea.
     * Stores the text in the state and the component answer property.
     */
    handleTextareaChange = (event) => {
        this.setState({ componentComment: event.target.value });
        this.updateComment(event.target.dataset.id, event.target.value);
    }

    /**
     * Resets the text area state to be empty.
     */
    handleTextareaClear = (event) => {
        this.setState({ componentComment: '' });
        this.updateComment(event.target.dataset.id, '');
    }

    /**
     * Toggles the state boolean to show/hide the textarea box.
     */
    handleTextareaToggle = () =>
        this.setState((prevState) =>
            ({ showTextarea: !prevState.showTextarea }));

    /**
     * Dispatches the action to update the component comment. Debounced so it 
     * is only called once the event(s) is/are done.
     */
    updateComment = debounce((componentID, textareaComment) => {
        this.props.actions.setComponentAnswer({
            id: componentID,
            comment: textareaComment
        });
    }, globalData.debounceTime);

    render() {
        const { actions, componentID, componentRating, didNotRun, displayName } = this.props;
        const dragItemClasses = classNames('tap-rating-component', {
            'textarea-open': this.state.showTextarea
        });
        const textareaToggleClasses = classNames('tap-rating-component__comment-toggle', {
            'has-text': this.state.componentComment
        });
        
        return (
            <li className={dragItemClasses}>
                <TappableStayComponentCard
                    actions={actions} 
                    componentID={componentID} 
                    componentRating={componentRating} 
                    displayName={displayName}
                    handleTextareaToggle={this.handleTextareaToggle}
                />

                <a className={textareaToggleClasses} onClick={this.handleTextareaToggle} />

                {this.state.showTextarea && (
                    <StayComponentCommentBox
                        componentComment={this.state.componentComment}
                        componentID={componentID} 
                        displayName={displayName}
                        didNotRun={didNotRun}
                        handleTextareaChange={this.handleTextareaChange}
                        handleTextareaClear={this.handleTextareaClear}
                        handleDidNotRun={this.handleDidNotRun}
                        handleTextareaToggle={this.handleTextareaToggle}
                    />
                )}
            </li>
        );
    }
}

export default TappableStayComponent;



// WEBPACK FOOTER //
// ./application/components/TappableStayComponent/TappableStayComponent.jsx